const color = {
  white: '#ffffff',
  black: '#000000',
  greyE: '#eeeeee',
  greyD: '#dddddd',
  grey9: '#999999',
  grey8: '#888888',
  grey7: '#777777',
  grey6: '#666666',
  grey5: '#555555',
  grey4: '#444444',
  grey3: '#333333',
  blue: '#1264a3',
  slackPurple: '#4a154b',
  green: '#007a5a',
  greenHover: '#148567',
  purple: '#4a154b',
  purpleHover: 'rgba(74,21,75,.9)',
};

export default color;
